export  const userModule = {
    state: 
    {
        userName: "" ,
        userId: "",
        
     },
  mutations: { },
  actions: {},
  getters: { }
}